/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ContextName } from './contextName';

export interface ContextPreferences { 
    context_name?: ContextName;
    disabled_channels?: Array<ContextPreferences.DisabledChannelsEnum>;
}
export namespace ContextPreferences {
    export type DisabledChannelsEnum = 'email' | 'messaging';
    export const DisabledChannelsEnum = {
        Email: 'email' as DisabledChannelsEnum,
        Messaging: 'messaging' as DisabledChannelsEnum
    };
}